import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useToast } from '@/lib/hooks/useToast';

const formSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  email: z.string().email({ message: 'Invalid email address' }),
  message: z.string().min(1, { message: 'Message is required' }),
});

export type ContactFormValues = z.infer<typeof formSchema>;

export const useContactForm = () => {
  const { toast } = useToast();

  const form = useForm<ContactFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: '',
      email: '',
      message: '',
    },
  });

  const onSubmit = async (values: ContactFormValues) => {
    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        toast({
          variant: 'default',
          description: 'Email sent successfully!',
        });
        form.reset();
      } else {
        toast({
          variant: 'destructive',
          description: 'Failed to send email, please try again.',
        });
      }
    } catch (error) {
      toast({
        variant: 'destructive',
        description: `An error occurred. Please try again later.\nError: ${error}`,
      });
      alert('An error occurred. Please try again later.');
    }
  };

  return { form, onSubmit };
};
